import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {formatCurrency, formatNumber} from "@angular/common";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import moment from "moment/moment";

export interface LTModelTable {
  milestone: string;
  scenario: string;
  sentDate: string;
  sentDateFormatted: string;
  hardDebt: string;
  lowerTierYield: string;
  lowerTierEquity: string;
  activeModel: boolean;
}

@Component({
    selector: 'deal-lt-model-exports',
    templateUrl: './lt-model-exports.component.html',
    styleUrls: ['./lt-model-exports.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LtModelExportsComponent implements OnInit{
  @Input() ltmodels: any;
  @ViewChild('dataSort') public dataSort: MatSort;

  modelDataSource: MatTableDataSource<LTModelTable>
  formattedModels: Array<LTModelTable>;
  modelColumns: string[] = ['milestone', 'scenario', 'sentDate', 'hardDebt', 'lowerTierYield', 'lowerTierEquity'];

  ngOnInit() {
    this.modelDataSource = new MatTableDataSource<LTModelTable>(this.formatLTModels(this.ltmodels));
  }

  ngAfterViewInit(){
    this.modelDataSource.sort = this.dataSort;
  }

  formatLTModels(models: any): Array<LTModelTable>{
    let formatted: Array<LTModelTable> = [];
    for(let i = 0; i < models.length; i++){
      let equity = 0;
      if(models[i].kpiset && models[i].kpiset.pricePerCredits){
        for(let j = 0; j < models[i].kpiset.pricePerCredits.length; j++){
          equity += models[i].kpiset.pricePerCredits[j]['equity_amount'];
        }
      }

      formatted.push({
        milestone: models[i].milestone ? models[i].milestone.name : '-',
        scenario: models[i].scenario ? models[i].scenario.name : '-',
        sentDate: models[i].created,
        sentDateFormatted: models[i].created ? moment
            .utc(models[i].created)
            .format('MM/DD/YYYY') : '',
        hardDebt: models[i].kpiset && models[i].kpiset.kpiset_detail && models[i].kpiset.kpiset_detail.hard_debt ?
          formatNumber(models[i].kpiset.kpiset_detail.hard_debt * 100, 'EN', '1.0-2').toString() + "%" : '-',
        lowerTierYield: models[i].kpiset && models[i].kpiset.kpiset_detail && models[i].kpiset.kpiset_detail.lower_tier_yield ?
          formatNumber(models[i].kpiset.kpiset_detail.lower_tier_yield * 100, 'EN', '1.0-6').toString() + "%" : '-',
        lowerTierEquity: formatCurrency(Math.trunc(equity), 'EN', '$', 'USD', '1.0-0'),
        activeModel: models[i].active_model
      })
    }
    let sorted = formatted.sort( this.compare );
    return sorted;
  }

  compare(a: any, b:any){
    if ( a.sentDate < b.sentDate ){
      return -1;
    }
    if ( a.sentDate > b.sentDate ){
      return 1;
    }
    return 0;
  }
}
